<!-- Dialog di warning per modifica nome work order / offerta -->
<h1 mat-dialog-title>{{ 'nameChangeWarningTitle' | translate }}</h1>

<div mat-dialog-content>
  <!-- Messaggio di avviso con icona warning -->
  <div class="warning-message">
    <mat-icon color="warn">warning</mat-icon>
    <span>{{ 'nameChangeWarningMessage' | translate }}</span>
  </div>
  
  <!-- Messaggio dettagliato -->
  <p class="warning-details">
    <span>{{ 'nameChangeWarningDetail' | translate }}</span>
  </p>

  <!-- Checkbox per non mostrare più il messaggio -->
  <mat-checkbox 
    [(ngModel)]="hideWarningInFuture" 
    color="primary"
    class="hide-warning-checkbox">
    {{ 'nameChangeWarningHideInFuture' | translate }}
  </mat-checkbox>
</div>

<!-- Pulsanti di azione -->
<div mat-dialog-actions style="justify-content: space-between;">
  <ct-button [configuration]="cancelButton"></ct-button>
  <ct-button [configuration]="confirmButton"></ct-button>
</div>
